
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';

export const GET_ORDER_STATS_SUCCESS = 'GET_ORDER_STATS_SUCCESS';
export const GET_ORDER_STATS_REQUEST = 'GET_ORDER_STATS_REQUEST';
export const GET_ORDER_STATS_FAILURE = 'GET_ORDER_STATS_FAILURE';

export const GET_RECENT_ORDERS_SUCCESS = 'GET_RECENT_ORDERS_SUCCESS';
export const GET_RECENT_ORDERS_REQUEST = 'GET_RECENT_ORDERS_REQUEST';
export const GET_RECENT_ORDERS_FAILURE = 'GET_RECENT_ORDERS_FAILURE';

export const GET_INCOME_SUCCESS = 'GET_INCOME_SUCCESS';
export const GET_INCOME_REQUEST = 'GET_INCOME_REQUEST';
export const GET_INCOME_FAILURE = 'GET_INCOME_FAILURE';

export const GET_DOWNLOAD_ORDER_INVOICE_SUCCESS = 'GET_DOWNLOAD_ORDER_INVOICE_SUCCESS';
export const GET_DOWNLOAD_ORDER_INVOICE_REQUEST = 'GET_DOWNLOAD_ORDER_INVOICE_REQUEST';
export const GET_DOWNLOAD_ORDER_INVOICE_FAILURE = 'GET_DOWNLOAD_ORDER_INVOICE_FAILURE';

export const PLACED_ORDER_SUCCESS = 'PLACED_ORDER_SUCCESS';
export const PLACED_ORDER_REQUEST = 'PLACED_ORDER_REQUEST';
export const PLACED_ORDER_FAILURE = 'PLACED_ORDER_FAILURE';

export const DELIVERED_ORDER_SUCCESS = 'DELIVERED_ORDER_SUCCESS';
export const DELIVERED_ORDER_REQUEST = 'DELIVERED_ORDER_REQUEST';
export const DELIVERED_ORDER_FAILURE = 'DELIVERED_ORDER_FAILURE';

export const CANCELED_ORDER_SUCCESS = 'CANCELED_ORDER_SUCCESS';
export const CANCELED_ORDER_REQUEST = 'CANCELED_ORDER_REQUEST';
export const CANCELED_ORDER_FAILURE = 'CANCELED_ORDER_FAILURE';

export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_REQUEST = 'DELETE_ORDER_REQUEST';
export const DELETE_ORDER_FAILURE = 'DELETE_ORDER_FAILURE';

export const SHIP_ORDER_SUCCESS = 'SHIP_ORDER_SUCCESS';
export const SHIP_ORDER_REQUEST = 'SHIP_ORDER_REQUEST';
export const SHIP_ORDER_FAILURE = 'SHIP_ORDER_FAILURE';

